import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { SharedModule } from '@shared/shared.module';

const addonUrl = `${environment.apiBaseUrl}platform/addons`;

@Injectable({
  providedIn: SharedModule
})
export class AddonService {

  constructor(private http: HttpClient) { }

  // use active param to lists data sources otherwise it lists add-ons
  list(
    {
      active,
      hasDataSource,
      hasVersion,
      isDashboardRequest
    }: {
      active?: boolean,
      hasDataSource?: boolean,
      hasVersion?: boolean,
      isDashboardRequest?: boolean
    }): Observable<Addon.AddonModel[]> {
    let params = new HttpParams();

    if (active) {
      params = params.append('active', 'true');
    }

    if (hasDataSource) {
      params = params.append('hasDataSource', 'true');
    }

    if (hasVersion) {
      params = params.append('hasVersion', 'true');
    }

    if (isDashboardRequest) {
      params = params.append('isDashboardRequest', 'true');
    }

    return this.http.get<Addon.AddonModel[]>(`${addonUrl}`, { params });
  }

  // get an add-ons detailed data
  get(id: string): Observable<Addon.AddonModel> {
    return this.http.get<Addon.AddonModel>(`${addonUrl}/${id}`);
  }

  // get an add-ons detailed data
  getDatasources(id: string): Observable<Addon.DatasourceListItem[]> {
    return this.http.get<Addon.DatasourceListItem[]>(`${addonUrl}/${id}/datasources`);
  }

  activate(id: string): Observable<Addon.AddonModel[]> {
    const headers = new HttpHeaders({
      'x-no-notification': 'true'
    });

    return this.http.post<Addon.AddonModel[]>(`${addonUrl}/${id}/activate`, {}, {headers});
  }

  getWidgets(id: string, scopeId?: string): Observable<any> {
    let params = new HttpParams();
    if (scopeId) {
      params = params.append('scope', scopeId);
    }
    return this.http.get<any>(`${addonUrl}/${id}/widget-templates`, {params});
  }

  createAddon(data: any): Observable<any> {
    return this.http.post<Addon.AddonModel[]>(`${addonUrl}/custom`, data, {});
  }
}
